export default {
  en: {
    notSupportBrowserTip: 'Sorry, IE browser is not supported on this website. Please download Chrome, 360 browser, Edge, Firefox, Opera and other browsers to visit.',
    betterBrowserTip: 'Sorry, the browser you use, can\'t access this website better, use Chrome, Safari or Opea to get a better experience.',
    htmltitle: 'XR Education Platform'
  },

  zh: {
    notSupportBrowserTip: '对不起，您使用的浏览器不支持访问本网站，请使用 Chrome、360浏览器、Safari 或 Opea等; 如果您正在使用浏览器的兼容模式，请切换成极速模式',
    betterBrowserTip: '对不起，您使用的浏览器不支持访问本网站，请使用 Chrome、360浏览器、Safari 或 Opea等; 如果您正在使用浏览器的兼容模式，请切换成极速模式',
    htmltitle: '未来课堂',
  }
}
